import requestApi from "@/utils/requestApi";
import commentItem from "../components/comment-item/index.vue";

export default {
  components: {
    commentItem,
  },
  data() {
    return {
      list: [],
      spuId: "",
      loading: null,
      pageNum: 1,
      total: 0,
      queryTypeList: null,
      goodsEvaRate: 0,
      evaluateCollect: {},
    };
  },
  created() {
    this.$store.commit("app/setShowTitle", true);
    this.$store.commit("app/setSellerMenuVisible", false);

    const { spuId } = this.$route.query;
    this.spuId = spuId;

    requestApi
      .post("sctrading/evaluate/selGoodsEvaluateCollect", {
        spuId,
      })
      .then((res) => {
        const { data } = res;
        this.evaluateCollect = data;
        this.goodsEvaRate = data.goodsEvaRate ? data.goodsEvaRate.match(/\d+/)[0] : "0";
      });

    this.loadData();
  },
  methods: {
    async loadData() {
      const { spuId, pageNum, queryTypeList } = this;

      this.loading = this.$loading({
        lock: true,
      });

      const { code, msg, data } = await requestApi.post("sctrading/evaluate/selGoodsEvaluateList", {
        spuId,
        pageNum,
        pageSize: 10,
        queryTypeList,
      });

      this.loading && this.loading.close();

      if (code != "0") {
        this.$message.error(msg);
        return;
      }

      const { list, total } = data;
      this.list = list;
      this.total = Number(total);

      this.$nextTick(() => {
        if (window.parent.parent.getIfrData) {
          setTimeout(() => {
            window.parent.parent.getIfrData(document.body.scrollHeight-136);
          }, 500);
        }
      });
    },
    // 切换类别
    classChange(arg) {
      this.pageNum = 1;
      this.queryTypeList = arg;

      this.loadData();
    },
    // 改变页码
    currentChange(pageNum) {
      this.pageNum = pageNum;

      this.loadData();
    },
  },
};
